module.exports = __webpack_public_path__ + "static/media/sparksOffice.13a62ffd.jpg";